import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperSpinner from "../../../helpers/spinner";
import helperNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import httpService from "../../../services/httpServices/httpServices";
import Pagination from "../../partials/content/Pagination";

export default function ViewAllPayment() {
  const params = useParams();
  const userID = params.userID;

  const [payments, setPayments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);

  useEffect(() => {
    getPayments();
  }, [currentPage, countItemPerPage]);

  const getPayments = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const payments = await sendRequestGetPayments();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!payments) {
      return;
    }

    setPayments(payments.payments);
    setCountPage(payments.count_page);
  };

  const sendRequestGetPayments = async () => {
    const headersRequest = getHeaderForRequest();
    let payments;
    try {
      payments = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/marketer/users/payments/${userID}?page=${currentPage}&number=${countItemPerPage}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return payments.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateDoseNotHaveAnyPayments = () => {
    return (
      <div className="d-flex flex-column flex-md-row">
        <div className="text-center text-md-right">
          <img class="img-fluid" src="/assets/img/do-not-have-invoices.svg" />
        </div>
        <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p> این کاربرتاکنون هیچ پرداختی ندارد.</p>
        </div>
      </div>
    );
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generatePayments = () => {
    return (
      <>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره پرداخت</td>
                <td>مبلغ پرداختی بدون احتساب مالیات بر ارزش افزوده (تومان)</td>
                <td>تاریخ پرداخت</td>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment, index) => {
                return (
                  <tr>
                    <td>{helperNumbers.toPersianNum(index + 1)}</td>
                    <td>{helperNumbers.toPersianNum(payment.id)}</td>
                    <td className="letter-spacing-finance-number">
                      {helperNumbers.toPersianNum(
                        helperNumbers.toFormatFinanceNumber(
                          Math.floor(
                            (payment.amount * 100) /
                              (100 +
                                parseInt(
                                  process.env
                                    .REACT_APP_TAX_PERCENT_AMOUNT_CHARGE
                                ))
                          )
                        )
                      )}
                    </td>
                    <td>{helperNumbers.toPersianNum(payment.paid_at)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {countPage > 1 && generatePagination()}
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="درخواست های تسویه حساب" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link
                  to="/marketer/all-user-registered"
                  className="btn btn-primary"
                >
                  <span className="pl-2">بازگشت</span>
                  <span>
                    <i className="fa fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {payments.length == 0
                ? generateDoseNotHaveAnyPayments()
                : generatePayments()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
